"use strict";
/*
 * This file is part of the Wrzasq.pl.
 *
 * @copyright 2016, 2018 - 2019, 2022, 2024 - 2025 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
require("./layout.scss");
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
const Modal_1 = require("./ui/Modal");
const ModalBox_1 = require("./ui/ModalBox");
const EuCookieNotice_1 = require("./util/EuCookieNotice");
const HtmlUtils_1 = require("./util/HtmlUtils");
const EXTERNAL_PATTERN = /^([a-z0-9]+:)?\/\//;
// integration with Google Analytics
if (!window.ga) {
    const f = (...params) => { ga.q.push(params); };
    window.ga = f;
    ga.q = [];
}
ga.l = new Date().getTime();
ga("create", "UA-274625-8", "auto");
ga("send", "pageview");
// end of Google Analytics integration
// configure Swiper to use modules
swiper_1.default.use([modules_1.Autoplay]);
document.addEventListener("DOMContentLoaded", () => {
    // make header better accessible
    const header = document.body.querySelector("body > header > nav");
    if (header) {
        new Headroom(header, {
            offset: 54,
        }).init();
    }
    // handle EU-law notice
    let div = document.createElement("div");
    document.body.appendChild(div);
    new EuCookieNotice_1.EuCookieNotice(div).render();
    // we use event delegation to make it persistent after page re-render
    document.body.addEventListener("click", (event) => {
        let target = event.target.closest("a") || event.target;
        if (target.tagName.toLowerCase() === "a" && target.hasAttribute("href")) {
            let href = target.getAttribute("href");
            if (href) {
                if (href[0] === "#") {
                    let section = document.getElementById(href.substring(1));
                    if (section) {
                        event.preventDefault();
                        (0, HtmlUtils_1.scrollToHash)(href);
                    }
                }
                else if (EXTERNAL_PATTERN.test(href)) {
                    event.preventDefault();
                    open(href);
                }
            }
        }
    });
    // modal box handler
    const container = document.getElementById("modal");
    if (container) {
        let modalBox = new ModalBox_1.ModalBox(container);
        (0, HtmlUtils_1.scrollToHash)(location.hash);
        // initialize modal boxes
        let boxes = document.querySelectorAll(".modal-item");
        let box;
        let details;
        for (box of boxes) {
            details = box.querySelector("details");
            if (details) {
                new Modal_1.Modal(modalBox, details).bind(box);
            }
        }
    }
    // initialize sliders
    let swipers = document.querySelectorAll(".swiper");
    for (let swiper of swipers) {
        new swiper_1.default(swiper, {
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
});
